// extracted by mini-css-extract-plugin
export default {"previewMobile":"styles_previewMobile__QnX3p","btAttachWeb":"styles_btAttachWeb__trLrI"};